export default __webpack_public_path__ + "static/media/tc.5a46575f.png";